module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_01_6DC79_1SD_HAV.0eb4f208.jpg";